const SubmissionsInboxItemSkeleton = () => {
  return (
    <div className="border border-gray-200 shadow rounded-md p-4 w-full mx-auto h-32">
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-6 py-1">
          <div className="space-y-7">
            <div className="grid grid-cols-3 gap-4">
              <div className="h-2 bg-slate-200 rounded col-span-2" />
              <div className="h-2 bg-slate-200 rounded col-span-1" />
            </div>
            <div className="grid grid-cols-3 gap-4">
              <div className="h-2 bg-slate-200 rounded col-span-2" />
            </div>
            <div className="grid grid-cols-4 gap-4">
              <div className="h-2 bg-slate-200 rounded col-span-1" />
              <div className="h-2 bg-white rounded col-span-1" />
              <div className="h-2 bg-white rounded col-span-1" />
              <div className="h-2 bg-slate-200 rounded col-span-1" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const SubmissionsInboxLoading = () => {
  return (
    <div className="flex flex-col">
      <SubmissionsInboxItemSkeleton />
      <SubmissionsInboxItemSkeleton />
      <SubmissionsInboxItemSkeleton />
    </div>
  );
};
